import { Accessor, createEffect, createSignal } from 'solid-js';
import { createStore } from 'solid-js/store';
import { createTimer } from '@solid-primitives/timer';

/**
 * 创建一个倒计时器更新器
 * @param endTime 结束时间
 * @param onEnd 结束回调
 * @returns
 */
export default function createCountdown(endTime: Accessor<number>) {
  function update(endTime: number) {
    let now = Date.now();
    if (now >= endTime) {
      now = endTime;
      return undefined;
    }
    const diff = Math.max(endTime - now, 0) / 1000;
    return {
      days: Math.floor(diff / 86400),
      hours: Math.floor((diff / 3600) % 24),
      minutes: Math.floor((diff / 60) % 60),
      seconds: Math.floor(diff % 60),
    };
  }

  const [cd, setCd] = createStore<Cd>({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  const active = useIsActive();
  const [state, setState] = createSignal<Cd | undefined>(update(endTime()));

  function updateState() {
    const et = endTime();
    const res = update(et);
    if (!res) {
      setState(undefined);
    } else {
      setCd(res);
      setState(cd);
    }
  }

  createTimer(
    updateState,
    () => (active() && state() ? 1000 : false),
    setInterval
  );
  createEffect(() => {
    active() && updateState();
  });

  return state;
}

interface Cd {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}
